import React from 'react';
import { Button } from '@mui/material';
import { COGNITO_CLIENT_ID, COGNITO_REDIRECT_SIGNIN_URL, COGNITO_USER_POOL_URL } from '../../config.js';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';

interface OAuthButtonProps {
  brand?: 'microsoft';
  title: string;
  identityProvider: string;
}

const useStyles = makeStyles(() => ({
  loginBtn: {
    maxHeight: '38px',
  },
}));

const OAuthButton = ({ title, identityProvider }: OAuthButtonProps) => {
  const classes = useStyles();
  const handleClick = () => {
    window.location.assign(
      `https://${COGNITO_USER_POOL_URL}/oauth2/authorize?identity_provider=${encodeURIComponent(identityProvider)}&redirect_uri=${COGNITO_REDIRECT_SIGNIN_URL}/&response_type=TOKEN&client_id=${COGNITO_CLIENT_ID}`
    );
  };

  return (
    <Button onClick={handleClick} fullWidth={false} className={classes.loginBtn}>
      {title}
    </Button>
  );
};

OAuthButton.propTypes = {
  brand: PropTypes.oneOf(['microsoft']),
};
export default OAuthButton;
